module.exports = __webpack_public_path__ + "static/media/thank-you.a16d27b6.svg";